import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CustomerResetPassword } from "api/Auth";
import { toast } from "react-toastify";
import "./ResetPassword.scss";

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token") || "";

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!token) {
            toast.error("Link đổi mật khẩu không hợp lệ");
            return;
        }
        if (password.length < 6) {
            toast.error("Mật khẩu phải có ít nhất 6 ký tự");
            return;
        }
        if (password !== confirmPassword) {
            toast.error("Mật khẩu xác nhận không khớp");
            return;
        }

        setLoading(true);
        try {
            const res = await CustomerResetPassword(token, password, confirmPassword);
            if (res.status) {
                setDone(true);
                toast.success("Đổi mật khẩu thành công!");
            } else if (res.error?.token_password_invalid) {
                toast.error("Link đổi mật khẩu không hợp lệ hoặc đã hết hạn");
            } else if (res.error?.password_confirm_error) {
                toast.error("Mật khẩu xác nhận không khớp");
            } else {
                toast.error(res.msg || "Đổi mật khẩu thất bại");
            }
        } catch {
            toast.error("Có lỗi xảy ra, vui lòng thử lại");
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="reset-password__container">
                <div className="reset-password__card reset-password__card--center">
                    <div className="reset-password__icon--status">⚠️</div>
                    <h2 className="reset-password__title">Link không hợp lệ</h2>
                    <p className="reset-password__subtitle">
                        Link đổi mật khẩu không hợp lệ hoặc đã hết hạn.<br />
                        Vui lòng thực hiện lại yêu cầu khôi phục mật khẩu.
                    </p>
                    <div className="styles_center__ijy9t">
                        <button
                            className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR styles_btn__7hepk"
                            onClick={() => navigate("/")}
                        >
                            <span className="MuiButton-label">Về trang chủ</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    if (done) {
        return (
            <div className="reset-password__container">
                <div className="reset-password__card reset-password__card--center">
                    <div className="reset-password__icon--status">✅</div>
                    <h2 className="reset-password__title">Đổi mật khẩu thành công</h2>
                    <p className="reset-password__subtitle">
                        Mật khẩu của bạn đã được cập nhật.<br />
                        Bạn có thể đăng nhập bằng mật khẩu mới.
                    </p>
                    <div className="styles_center__ijy9t">
                        <button
                            className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR styles_btn__7hepk"
                            onClick={() => navigate("/?action=login")}
                        >
                            <span className="MuiButton-label">Đăng nhập ngay</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="reset-password__container">
            <div className="reset-password__card">
                <div className="reset-password__icon">
                    <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z" fill="currentColor"/>
                    </svg>
                </div>
                <h2 className="reset-password__title">Đặt mật khẩu mới</h2>
                <p className="reset-password__subtitle">Nhập mật khẩu mới cho tài khoản của bạn</p>

                <form onSubmit={handleSubmit}>
                    <div className="reset-password__field">
                        <label className="reset-password__label">Mật khẩu mới</label>
                        <input
                            className="reset-password__input"
                            name="password"
                            placeholder="Nhập mật khẩu mới (ít nhất 6 ký tự)"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="reset-password__field">
                        <label className="reset-password__label">Xác nhận mật khẩu</label>
                        <input
                            className="reset-password__input"
                            name="confirmPassword"
                            placeholder="Nhập lại mật khẩu"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            autoComplete="new-password"
                        />
                    </div>

                    <div className={`styles_center__ijy9t reset-password__actions`}>
                        <button
                            className={`MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR styles_btn__7hepk${loading ? " reset-password__btn--loading" : ""}`}
                            type="submit"
                            disabled={loading}
                        >
                            <span className="MuiButton-label">
                                {loading ? "Đang xử lý..." : "Đổi mật khẩu"}
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
